/* eslint-disable react/style-prop-object */
import React, { useContext, useState } from "react";
import Searchbar from "../../Helpers/Searchbar/Searchbar";
import { filtrationcontext } from "../../../context/Filtercontext";
import Button from "../../Helpers/Button/Button";
import { popupcontext } from "../../../context/Popupscontext";
import EventsFilter from "../EventsFilter/EventsFilter";
import trans, { isRTL } from "../../../utils";

export default function EventsHead({
  setStartDate,
  startDate,
  setEndDate,
  endDate,
  selectedUser,
  selectedId,
  setSelectedUser,
  setSelectedId,
  setIsShown,
  isShown,
}) {
  const { setSearchQuery } = useContext(filtrationcontext);
  const { handleShow } = useContext(popupcontext);
  const [query, setQuery] = useState("");
  const handleSearch = (e) => {
    setQuery(e.target.value);
    setSearchQuery(e.target.value);
  };
  return (
    <>
      <div className="flex-between bg-white p-16 events-head mb-3">
        <Searchbar
          style="search search-dark input-group"
          path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
          placeholder={trans("Search")}
          value={query}
          onChange={handleSearch}
        />
        <Button
          type={"default"}
          text={trans("Filter")}
          img2={isRTL ? "Filter.svg" : ""}
          img={!isRTL ? "Filter.svg" : ""}
          onClick={() => {
            handleShow("addForm");
            setIsShown(false);
          }}
        />
        <EventsFilter
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          selectedUser={selectedUser}
          selectedId={selectedId}
          setSelectedUser={setSelectedUser}
          setSelectedId={setSelectedId}
          isShown={isShown}
          setIsShown={setIsShown}
        />
      </div>
    </>
  );
}
